<div class="flex flex-column justify-content-between h-full w-full">
    <div class="flex justify-content-end pt-3 w-full cursor-pointer" (click)="onClose(false)">
        <i class="pi pi-times text-lg text-primary-500 hover:surface-200"></i>
    </div>
    <div class="flex flex-column gap-3 w-full">
        <div class="w-full padding-px-24 text-lg text-semibold">
            {{ 'default-admin-filters-confirm-deletion' | translate: title }}
        </div>
        <span class="text-gray-300 font-normal pb-3"
            >{{ 'default-cm-deleteConfirmationMessage' | translate }}
            @if (itemName) {
                ‘<b>{{ itemName }}</b
                >’
            }
            ?
        </span>
        <div class="flex w-full gap-3">
            <p-button
                class="w-full"
                [outlined]="true"
                label="Delete"
                styleClass="w-full"
                (onClick)="onClose(true)"
            ></p-button>
            <p-button class="w-full" label="Cancel" styleClass="w-full" (onClick)="onClose(false)"></p-button>
        </div>
    </div>
</div>
